import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { DATE_RANGES } from "../../../constants/datesList";
import { RightSection } from "./RightSection";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { Link } from "react-router-dom";
import { useGetAgencyDashboardTasksQuery } from "../../../redux/api/authApi";
import { TASK_STATUSES } from "../../../constants/task";
import BaseCard from "../../BaseCard/BaseCard";

export default function FollowUpTasks({ agencyId }) {
  const methods = useForm();
  const [selectAll, setSelectAll] = useState(true);

  // Watch for agentid changes
  const agentId = useWatch({
    control: methods.control,
    name: "agentid",
  });

  // Fetch tasks based on current selection
  const {
    data = {},
    isFetching,
    refetch,
  } = useGetAgencyDashboardTasksQuery({
    agcId: agencyId,
    recAgtId: selectAll ? null : agentId,
  });

  // Auto sync checkbox & agent selection logic
  useEffect(() => {
    if (agentId) {
      setSelectAll(false); // Agent is selected, uncheck Select All
    }
  }, [agentId]);

  useEffect(() => {
    if (selectAll) {
      methods.setValue("agentid", null); // Select All is checked, clear agent
    }
    // Refetch data when selection changes
    refetch();
  }, [selectAll, methods, refetch]);

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <>
      <BaseCard title="Tasks" sx={{ flex: 1 }}>
        <Box
          display="flex"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
          }}
          alignItems="center"
          mb={2}
          justifyContent="end"
        >
          {/* <Typography variant="h2" fontWeight="bold" mr={2}>
            Tasks
          </Typography> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <Box position="relative" display="flex">
              <NotificationsActiveIcon
                sx={{ color: "#F59E0B", mr: 1, fontSize: 35 }}
              />
              {data?.Today > 0 && (
                <Box
                  position="absolute"
                  top={-5}
                  right={5}
                  bgcolor="#FF0033"
                  color="white"
                  borderRadius="50%"
                  width={17}
                  height={17}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="12px"
                  fontWeight="bold"
                >
                  {data.Today}
                </Box>
              )}
            </Box>
            <Box>
              <Typography fontWeight="bold" fontSize="15px">
                Follow-up schedule
              </Typography>
              <Typography fontSize="12px">
                {data?.Today || 0} follow-up(s) scheduled for{" "}
                <b>today ({today})</b>
              </Typography>
            </Box>
          </Box>
        </Box>

        <List>
          {[
            ...DATE_RANGES,
            ...TASK_STATUSES.map((s) => ({
              ...s,
              isStatus: true,
            })),
          ].map((item) => {
            const isStatus = item.isStatus;

            const taskMap = {
              all: data?.AllData || 0,
              daily: data?.Today || 0,
              next7: data?.NextWeek || 0,
              last7: data?.PreviousWeek || 0,
              month: data?.ThisMonth || 0,
              0: data?.Unhandeld || 0,
              1: data?.completed || 0,
              2: data?.progress || 0,
              3: data?.overdue || 0,
            };

            const count = taskMap[item.value] || 0;

            const searchParam = isStatus
              ? `status=${item.label}`
              : `range=${item.value}`;

            return (
              <ListItem
                key={`${item.value}-${isStatus}`}
                disableGutters
                sx={{ py: 0.5 }}
                divider
              >
                <Link
                  to={{
                    pathname: "/tasks",
                    search: `?${searchParam}${
                      !selectAll && agentId ? `&agentId=${agentId}` : ""
                    }`,
                  }}
                  style={{ width: "100%", textDecoration: "none" }}
                >
                  <ListItemText
                    primary={
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography fontSize={13}>{item.label}</Typography>
                        <Typography fontSize={13} color="text.secondary">
                          ({count} tasks)
                        </Typography>
                      </Box>
                    }
                    primaryTypographyProps={{ fontSize: 14 }}
                  />
                </Link>
              </ListItem>
            );
          })}
        </List>
      </BaseCard>

      {/* Right Section (Filters) */}
      <BaseCard title="Task Status" sx={{ flex: 1 }}>
        <FormProvider {...methods}>
          <RightSection
            agencyId={agencyId}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
          />
        </FormProvider>
      </BaseCard>
    </>
  );
}
